<template>
  <div class="boxHide" :class="{show:data_isShow}">
    <div class="mask" @click="close_fn"></div>
    <div id="Modal">
      <div :class="`title ${data_title?'titleBg':'notTitle'}`">
        <span class="titleText">{{data_title}}</span>
        <div class="close" @click="close_fn" v-if="(data_closeBtn === undefined || data_closeBtn === true)">
          <PlusOutlined/>
        </div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import {PlusOutlined} from '@ant-design/icons-vue';

  export default {
    name: "Modal",
    components: {
      PlusOutlined,
    },
    props: ['data_title', 'data_isShow', 'data_closeBtn'],
    methods: {
      // 关闭按钮
      close_fn() {
        this.$emit('update:data_isShow', false)
      }
    },
  }
</script>

<style scoped lang="scss">
  /* 弹框默认隐藏 */
  .boxHide {
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s;
    position: fixed;
    z-index: 99;
  }

  /* 显示弹框 */
  .show {
    opacity: 1;
    visibility: visible;
  }

  /* 遮罩 */
  .mask {
    width: 100%;
    height: 100%;
    background: rgba(51, 51, 51, 0.3);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
  }

  /* 内容 */
  #Modal {
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 1;
    transform: translate(-50%, -50%);
    background: #FFFFFF;
    border-radius: 6px;
    overflow: hidden;

    .title {
      line-height: 50px;
      height: 50px;
      padding: 0 30px;
      font-size: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;

      &.notTitle{
      padding: 0 12px;
      }

      &.titleBg {
        /*background: #F2F2F2;*/
        margin-top: 10px;
      }

      .titleText{
        margin: 0 auto;
      }

      .close {
        color: #a8a8a8;
        background: #f6f6f6;
        width: 26px;
        height: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        cursor: pointer;
        position: absolute;
        right: 30px;

        span {
          transform: rotate(45deg);
        }
      }
    }
  }


</style>
